// extracted by mini-css-extract-plugin
export default {"asyncSvg":"AsyncSvg_asyncSvg__Mq9cR"};